export default __webpack_public_path__ + "static/media/C_Cenoura.cb616b86.svg";